import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { LogErrors } from './../../../../../../utilities/LogErrors'

//import { InstructorBase } from './../../../../../Layouts/Instructor/InstructorBase'
import { InstructorBase } from './../../../../../Layouts/Instructor/V2/InstructorBase'
import { Message } from './../../../../../Common/Message'

import { CreateGroup as BLCreateGroup } from './../../../../../../utilities/BL/Instructor/Groups'
import { SaveGroupToShow } from './../../../../../../utilities/BL/Navigation'
import { ValidateSession } from './../../../../../../utilities/BL/Sessions'
import { HELP_TYPE } from './../../../../../../utilities/EL/HelpType'
import { WEBPAGES } from './../../../../../../utilities/EL/WebPages'
//import { HELP_TYPE } from './../../../../../Header/Header'
//import { useTawkChat } from './../../../../../../Support/Chat/Chat'


const Create = () => {
    const navigate = useNavigate()

    const [errorMessage,setErrorMessage] = useState(null)
    const [copyState, setCopyState] = useState('initial') // 'initial' | 'copied' | 'again'

    const [showCreateButton,setShowCreateButton] = useState(true)
    const [showCreatedMessage,setShowCreatedMessage] = useState(false)

    const [isWorking,setIsWorking] = useState(false)
    const [groupData,setGroupData] = useState(null)
    const [groupName,setGroupName] = useState(null)
    

    //--- Calls to API ----//

    const ShowGroup = async (group) => {
        try {
            // Guardar en navigation el grupo para detectarlo en la página /groups/group
            const response = await SaveGroupToShow(group.idGroup, group.groupName)

            if (response.success) {
                navigate("/instructor/groups/group/")
            }
        } catch (error) {
            
        }
    }

    const CreateGroup = async () => {
        try {
            setIsWorking(true)
            setErrorMessage(null)
            
            const response = await BLCreateGroup(groupName)
            
            if (response.success) {
                setGroupData(response.data)
                setShowCreateButton(false)
                setShowCreatedMessage(true)
            } else {
                setErrorMessage(response.message)
            }
        } catch (error) {
            
        } finally {
            setIsWorking(false)
        }
    }

    //--- Calls to API ----//



    const ShowCreateGroup = async () => {
        try {
            setGroupName(null)
            setErrorMessage(null)
            setShowCreatedMessage(false)
            setShowCreateButton(true)
        } catch (error) {
            
        }
    }

    const CopyAccessCode = () => {
        try {
            setErrorMessage(null)

            if (groupData?.accessCode) {
                navigator.clipboard.writeText(groupData.accessCode)

                setCopyState('copied')

                setTimeout(() => {
                    setCopyState('again')
                }, 1000)
            } else {
                setErrorMessage('No ha sido posible copiar el Código Ztudia. Inténtalo nuevamente o intenta copiarlo manualmente.')
            }
        } catch (error) {
            LogErrors('NextStepButton - Group', 'No ha sido posible copiar el Código Ztudia. Inténtalo nuevamente o intenta copiarlo manualmente. Error:' + error)
            setErrorMessage('No ha sido posible copiar el Código Ztudia. Inténtalo nuevamente o intenta copiarlo manualmente.')
        }
    }

    useEffect(() => {
        async function Validate() {
            const tmpSession = await ValidateSession()
            
            if (tmpSession.success) {
                if (!tmpSession.data.user.userStatus === 2) {
                    navigate('/confirm')
                }
            } else {
                navigate(`/?logout=${process.env.REACT_APP_LOGOUT_PARAMETER}`)
            }
        }
        Validate()
    }, [])


    //useTawkChat(true) // Activamos el chat en esta página


    return (
        <>
            <InstructorBase urlToGo={'/instructor/groups'} idHelp={HELP_TYPE.INSTRUCTOR.GROUPS_CREATE} page={WEBPAGES.INSTRUCTOR.GROUPS}>
                {showCreateButton && (
                    <section className='container Instructor__Groups__Create'>
                        <p className='Instructor__Title Instructor__Title--Center Instructor__SpaceUp'>Crear grupo</p>
                        <input type='text' className='Instructor__Groups__Create__Input' placeholder='Nombre del grupo' value={groupName || ''} onChange={(e) => setGroupName(e.target.value)}/>
                        {isWorking ? (
                            <p className='Btn__Ztudia--Disabled Instructor__Text--Center Instructor__Groups__Create__Button'>Trabajando...</p>
                        ) : (
                            <button type='button' className='Btn__Ztudia--Primary Instructor__Groups__Create__Button' onClick={CreateGroup}>Crear grupo ahora</button>
                        )}
                        {errorMessage && errorMessage !== '' && <p className='Instructor__Message--Error'>{errorMessage}</p>}
                    </section>
                )}

                {showCreatedMessage && (
                    <section className='container Instructor__Groups__Create'>
                        <Message
                            icon={'bi bi-check-circle-fill'}
                            title={'¡Muy bien!'}
                            subtitle={`Grupo ${groupData?.groupName && "'" + groupData.groupName + "' "} creado con éxito`}
                            extraClassName={'Instructor__Groups__Create__Message'}
                        >
                            <p className='Instructor__Groups__Create__Message__Text Instructor__SpaceUp'>Ahora puedes compartir el código Ztudia a tus Ztudiantes para que se unan a tu grupo.</p>
                            <p className='Instructor__Groups__Create__Message__Text'>Código Ztudia</p>
                            <p className='Instructor__Groups__Create__Message__Text Instructor__Groups__Create__Message__Text--AccessCode'>{groupData?.accessCode && groupData.accessCode}</p>
                            <div>
                                <button type='button' className='Btn__Ztudia--PrimaryOutline Instructor__Groups__Create__Button' onClick={CopyAccessCode}>
                                    {copyState === 'copied'
                                        ? 'Código copiado'
                                        : copyState === 'again'
                                        ? 'Copiar código nuevamente'
                                        : 'Copiar código'}
                                </button>
                            </div>
                        </Message>

                        <p className='Instructor__Text--Center Instructor__SpaceUp'>¿Qué te gustaría hacer ahora?</p>
                        
                        <button type='button' className='Btn__Ztudia--Primary Instructor__Groups__Create__Button' onClick={() => navigate('/instructor/agenda')}>Agendar evaluación al grupo</button>
                        <button type='button' className='Btn__Ztudia--PrimaryOutline Instructor__Groups__Create__Button' onClick={ShowCreateGroup}>Crear otro grupo</button>
                        <button type='button' className='Btn__Ztudia--Link Instructor__AccessCodeButton Instructor__Groups__Create__Button' onClick={() => ShowGroup(groupData)}>Ver grupo</button>

                        {/* <button type='button' className='Btn__Ztudia--Primary Instructor__Groups__Create__Button' onClick={ShowCreateGroup}>Crear otro grupo</button>
                        <button type='button' className='Btn__Ztudia--PrimaryOutline Instructor__AccessCodeButton Instructor__Groups__Create__Button' onClick={() => ShowGroup(groupData)}>Ver grupo</button> */}
                    </section>
                )}
            </InstructorBase>
        </>
    )
}

export { Create };